export const CHANGE_DEV_MODE = 'ethstats/global/CHANGE_DEV_MODE';
export const CHANGE_ICONS_TYPE = 'ethstats/global/CHANGE_ICONS_TYPE';
export const CHANGE_NODE_HISTORY_VISIBILITY = 'ethstats/global/CHANGE_NODE_HISTORY_VISIBILITY';
export const CHANGE_TICK_TIMER = 'ethstats/global/CHANGE_TICK_TIMER';
export const CHANGE_GO_TO_HISTORY = 'ethstats/global/CHANGE_GO_TO_HISTORY';
export const CHANGE_HISTORY_BLOCK = 'ethstats/global/CHANGE_HISTORY_BLOCK';
export const CHANGE_SMALL_CHART_BAR_COUNT = 'ethstats/global/CHANGE_SMALL_CHART_BAR_COUNT';
export const CHANGE_BIG_CHART_BAR_COUNT = 'ethstats/global/CHANGE_BIG_CHART_BAR_COUNT';
export const CHANGE_CONNECT_NODE_VISIBILITY = 'ethstats/global/CHANGE_CONNECT_NODE_VISIBILITY';
